import { Network } from "../../network";
import { NFT } from "../nft";
export const openseaAssetToNFT = (asset, owner) => {
    return new NFT({
        owners: [{ address: owner, quantity: 1 }],
        name: asset.name,
        network: Network.ETHEREUM,
        collectionId: asset.asset_contract.address,
        tokenId: asset.token_id,
        imageUrl: asset.image_url ||
            asset.image_original_url ||
            asset.image_preview_url ||
            asset.image_thumbnail_url,
        attributes: asset.traits.map((trait) => ({
            traitType: trait.trait_type,
            value: trait.value,
        })),
        collection: {
            name: asset.collection.name || "",
            description: asset.collection.description || "",
            imageUrl: asset.collection.banner_image_url || "",
        },
    });
};
